import { ErrorCode } from 'react-dropzone';

import {
  UPLOADING_DENTAL_PHOTO_MAX_SIZE,
  UPLOADING_DENTAL_PHOTO_ZIP_MAX_SIZE,
} from '@/shared/config';

export const validateDentalPhotoFileSize = (file: File) => {
  if (file.type === 'application/zip') {
    if (file.size > UPLOADING_DENTAL_PHOTO_ZIP_MAX_SIZE) {
      return {
        code: ErrorCode.FileTooLarge,
        message: `File is larger than ${UPLOADING_DENTAL_PHOTO_ZIP_MAX_SIZE} bytes`,
      };
    }

    return null;
  }

  if (file.size > UPLOADING_DENTAL_PHOTO_MAX_SIZE) {
    return {
      code: ErrorCode.FileTooLarge,
      message: `File is larger than ${UPLOADING_DENTAL_PHOTO_MAX_SIZE} bytes`,
    };
  }

  return null;
};
